export enum UserType {
  doctor = 'doctor',
}
